import Vue from 'vue'
import Router from 'vue-router'
import routes from './setting/routes'

Vue.use(Router)

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location)
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})
// 进入新页面时 页面滚动条回顶部
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})

export default router
